import type { Route } from '~/core/router'

import * as pinLockFeature from '~/features/pin-lock'
import { AccountSettingsModal } from '~/features/portal/redirect'
import * as root from '~/routes/error/root'
import { keys } from '~/shared/jail'
import { NavBar } from '~/widgets/NavBar'
import { AnnouncementPopup, ProfilesRemovePopup } from '~/widgets/Popups'

export const route: Route = {
  keys: [keys.master],

  children: [
    {
      path: '',
      component: [
        root.Title,
        NavBar,
        root.ErrorPage,
        ProfilesRemovePopup,
        AnnouncementPopup,
        AccountSettingsModal,
        pinLockFeature.PinLockPopup,
      ],
      init: root.model.init,
    },
  ],
}
